import React from 'react'
import styled from 'styled-components';
import IconText from '../MobileFooterMenu/IconText';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';


const StyledRegisterIconLink = styled.button`
    display: flex;
    flex-direction: column;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
  }
`;

const RegisterCustomerLink = () => {
  const { registerUserUrl } = useTypedSelector(
    (state) => state.login
  );

  return (
    <StyledRegisterIconLink className='flex items-center gap-1'
      onClick={() => window.location.href = registerUserUrl!}
      title={translate('general.become-customer-desktop')}
      role='button'
      aria-label={translate('general.become-customer-desktop')}
    >
      <Icon name='register-user' />
      <IconText translationKey='general.become-customer-desktop'></IconText>
    </StyledRegisterIconLink>
  )
}

export default RegisterCustomerLink